export default "__VITE_ASSET__WObsN0sH__"